// extracted by mini-css-extract-plugin
export default {"project":"project_project__NMJAc","icon":"project_icon__QNtY9","text":"project_text__R4fTJ","projectLink":"project_projectLink__ppuTa","title":"project_title__4z7kZ"};